export interface IStockLocationHistoryCreator {
    email: string;
    first_name: string;
    last_name: string;
}
